export function getHtmlInputValue(id) {
    const inputElement = document.getElementById(id);
    return inputElement ? inputElement.value : undefined;
}
export function getHtmlCheckBoxValue(id) {
    const inputElement = document.getElementById(id);
    return inputElement ? inputElement.checked : undefined;
}
